import React from 'react';
import { motion } from 'framer-motion';
export function Differentiator() {
  return <section className="py-24 px-6 bg-white" data-id="element-73">
      <div className="max-w-3xl mx-auto text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-6" data-id="element-76">
            Nosotros estamos de tu lado
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-77">
            Te representamos desde el inicio para que tomes una buena decisión y
            no pagues de más en el proceso.
          </p>
        </motion.div>
      </div>
    </section>;
}